function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawFilesSent = function UndrawFilesSent(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1045.041 777.3",
    style: style
  }, props), React.createElement("circle", {
    cx: 352.041,
    cy: 475.499,
    r: 45,
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M486.04 553.265c0 58.48-34.765 78.9-77.651 78.9s-77.652-20.42-77.652-78.9 77.652-132.878 77.652-132.878 77.652 74.397 77.652 132.878z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M405.56 623.219l.795-48.943 33.098-60.55-32.973 52.872.358-22.007 22.81-43.807-22.716 37.983v.001l.643-39.581 24.426-34.876-24.325 28.652.402-72.576-2.525 96.078.208-3.964-24.834-38.012 24.435 45.621-2.314 44.204-.068-1.173-28.63-40.003 28.543 44.148-.289 5.528-.052.083.023.454-5.87 112.151h7.843l.941-57.928 28.473-44.04-28.402 39.685z"
  }), React.createElement("path", {
    d: "M888.04 586.182c0 43.419-25.81 58.579-57.651 58.579s-57.652-15.16-57.652-58.579 57.652-98.654 57.652-98.654 57.652 55.236 57.652 98.654z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M828.289 638.119l.59-36.337 24.573-44.955-24.48 39.254.265-16.338 16.936-32.525-16.866 28.201.478-29.386 18.135-25.894-18.06 21.273.298-53.884-1.874 71.332.154-2.942L810 527.696l18.142 33.871-1.718 32.819-.051-.871-21.256-29.7 21.191 32.777-.214 4.104-.039.062.018.337-4.359 83.265h5.824l.698-43.008 21.139-32.696-21.086 29.463z"
  }), React.createElement("ellipse", {
    cx: 560.928,
    cy: 697.361,
    rx: 455,
    ry: 23,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 838.11,
    cy: 735.361,
    rx: 77.931,
    ry: 3.939,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 556.11,
    cy: 773.361,
    rx: 77.931,
    ry: 3.939,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 342.164,
    cy: 741.499,
    rx: 178.043,
    ry: 9,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M564.35 266.813s-33.533 28.645-35.964 35.434-32.387 40.25-35.598 42.636-39.542 30.617-29.382 39.264 38.12-25.824 38.12-25.824 46.997-42.382 52.433-50.157 24.106-22.889 24.106-22.889z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M564.35 266.813s-33.533 28.645-35.964 35.434-32.387 40.25-35.598 42.636-39.542 30.617-29.382 39.264 38.12-25.824 38.12-25.824 46.997-42.382 52.433-50.157 24.106-22.889 24.106-22.889z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M565.54 452s-2 32-5 38-2 17-1 18 42 16 52 25 40 26 43 26 16 46 16 46l-48-36s-18-11-23-11-62-24-68-25 9-88 9-88z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M565.54 452s-2 32-5 38-2 17-1 18 42 16 52 25 40 26 43 26 16 46 16 46l-48-36s-18-11-23-11-62-24-68-25 9-88 9-88z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M506.54 452l-11 70 13 40s11 50 13 58 0 75 0 75 18-1 19-2 15-48 15-48-11-6-9-26-6.138-75.574-9.569-84.288S543.541 478 559.541 459s-53-7-53-7z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M549.54 646s-8 41-30 46c0 0-16 8-13 12s31 2 34 0 14-31 14-31l6 22 12-7-5-29s-9-25-18-13zM520.54 343v48s-21 64-16 66 56 12 59 7 28 2 32-3 0-72-3-80-6-40-6-40z",
    fill: "#2f2e41"
  }), React.createElement("circle", {
    cx: 564.541,
    cy: 172.999,
    r: 32,
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M549.54 194s10 31-1 35 12 21 13 21 21-21 21-21l8-16s-10-17-5-28-36 9-36 9z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M590.54 208a91.845 91.845 0 0 1-16 14c-9 6-24 12-24 9s4-7 0-7-15 9-15 11-7 21-13 24-12 23-12 30-5 54 5 57 16 7 23 4 11-7 20-5 23-3 28 1 15 2 17-1 13-112 9-114-13-12-15-15a75.087 75.087 0 0 0-7-8z",
    fill: "#575a89"
  }), React.createElement("path", {
    d: "M648.54 559s21 39 17 45-6 21-3 21 27-19 22-29-12-25-12-25l22 7 4-13-28-12s-17-2-22 6z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M592.54 304s3 44 7 50 13 50 13 54 1 50 14 47 2-46 2-46-6-63-9-72-4-33-4-33z",
    fill: "#a0616a"
  }), React.createElement("path", {
    d: "M638.868 202.818c-6.489-9.768-11.846-25.478-17.627-39.315-1.874-4.484-3.586-9.027-5.262-13.589-3.378-9.194-18.085-21.063-37.347-21.063-22.015 0-39.862 11.08-39.862 20.374 0 7.686 12.204 14.163 28.872 16.178-5.856 13.071-9.384 27.578-9.384 37.415 0 22.26 18.045 12.845 40.305 12.845s52.623 5.697 40.305-12.845z",
    fill: "#2f2e41"
  }), React.createElement("path", {
    d: "M598.54 233s-21 37-20 52-4 30 4 30 34 0 36-4 1-51 0-57-5-23-5-23z",
    fill: "#575a89"
  }), React.createElement("path", {
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M685.041 440.499h293v-150M397.041 166.499h-293v150"
  }), React.createElement("path", {
    d: "M1030.06 142.288l-79.672-10.043c-3.611-30.038 1.844-59.362 11.158-88.524l79.672 10.043a163.846 163.846 0 0 0-11.159 88.524z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M972.678 54.32l48.688 6.138-.66 5.23-48.688-6.136z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M961.423 65.78l65.991 8.317-.33 2.616-65.99-8.319zM960.357 74.229l65.991 8.318-.33 2.616-65.99-8.319zM959.292 82.68l65.991 8.317-.33 2.616-65.99-8.319zM958.227 91.13l65.991 8.317-.33 2.616-65.99-8.319zM957.162 99.58l65.991 8.317-.33 2.616-65.99-8.319zM956.097 108.03l65.991 8.317-.33 2.616-65.99-8.319zM955.032 116.48l65.991 8.317-.33 2.616-65.99-8.319z"
  }), React.createElement("path", {
    d: "M992.33 112.695L917.794 82.82C921.9 52.846 934.598 25.856 950.988 0l74.538 29.876a163.846 163.846 0 0 0-33.195 82.82z",
    fill: "#e6e6e6"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M959.076 13.073l45.55 18.257-1.962 4.893-45.55-18.257z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M945.287 21.309l61.739 24.745-.981 2.447-61.738-24.746zM942.12 29.215l61.737 24.746-.98 2.446-61.739-24.745zM938.95 37.12l61.738 24.746-.98 2.447-61.739-24.746zM935.781 45.026L997.52 69.77l-.981 2.447L934.8 47.472zM932.613 52.932l61.738 24.746-.98 2.446-61.739-24.745zM929.444 60.837l61.739 24.745-.981 2.447-61.739-24.746zM926.275 68.743l61.738 24.745-.98 2.447-61.739-24.746z"
  }), React.createElement("path", {
    d: "M973.897 119.89h-80.302c-7.339-29.35-5.594-59.126 0-89.224h80.302a163.846 163.846 0 0 0 0 89.225z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M905.965 39.791h49.073v5.272h-49.073z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.3,
    d: "M896.231 52.567h66.513v2.636h-66.513zM896.231 61.084h66.513v2.636h-66.513zM896.231 69.601h66.513v2.636h-66.513zM896.231 78.117h66.513v2.636h-66.513zM896.231 86.634h66.513v2.636h-66.513zM896.231 95.151h66.513v2.636h-66.513zM896.231 103.668h66.513v2.636h-66.513z"
  }), React.createElement("path", {
    d: "M919.77 102.079L892.103 80.57a3.158 3.158 0 0 0-2.737-1.584h-14.932a3.158 3.158 0 0 0-3.158 3.158v131.786a10.243 10.243 0 0 0 10.244 10.244h153.276a10.243 10.243 0 0 0 10.244-10.244V111.39a9.31 9.31 0 0 0-9.31-9.31z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M1012.026 132.641h27.802v9.731h-27.802z"
  }), React.createElement("path", {
    d: "M187.439 570.776H20.819A20.602 20.602 0 0 1 .215 550.174v-76.337a8.162 8.162 0 0 1 2.547-5.923l88.293-83.694a19.003 19.003 0 0 1 26.146 0l84.182 79.797a21.334 21.334 0 0 1 6.657 15.484v70.673a20.602 20.602 0 0 1-20.602 20.602z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M.216 475.09H206.31v66.954a28.732 28.732 0 0 1-28.732 28.732H28.949A28.732 28.732 0 0 1 .216 542.044v-66.953z",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 27.277,
    y: 409.496,
    width: 153.27,
    height: 153.27,
    rx: 11.336,
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M180.547 478.533v84.233H27.277v-84.233l76.635 37.04 76.635-37.04z"
  }), React.createElement("path", {
    d: "M103.912 520.336L5.718 472.875A3.984 3.984 0 0 0 0 476.462v81.658a12.44 12.44 0 0 0 12.44 12.44h182.944a12.44 12.44 0 0 0 12.44-12.44V477.86a4.862 4.862 0 0 0-6.977-4.377z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    fill: "#f2f2f2",
    d: "M40.482 423.567h42.864v6.062H40.482zM37.019 445.649h127.292v3.464H37.019zM37.019 457.339h127.292v3.464H37.019zM37.019 469.029h127.292v3.464H37.019z"
  }), React.createElement("ellipse", {
    cx: 33.555,
    cy: 411.91,
    rx: 17.752,
    ry: 17.784,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M33.555 391.095A21.215 21.215 0 1 0 54.77 412.31a21.278 21.278 0 0 0-21.215-21.215zM29.2 423.622l-10.873-10.873 3.05-3.05 7.833 7.833L45.744 401l3.05 3.05L29.2 423.621z",
    fill: "#57b894"
  }));
};
UndrawFilesSent.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawFilesSent;